const KEY = "svj_pending_payment";
const MAX_AGE = 15 * 60 * 1000;

export const savePending = (id) => localStorage.setItem(KEY, JSON.stringify({ id, at: Date.now() }));
export const clearPending = () => localStorage.removeItem(KEY);
export const readPending = () => {
  try {
    const p = JSON.parse(localStorage.getItem(KEY));
    if (p && Date.now() - p.at < MAX_AGE) { return p.id; }
  } catch {
    return null;
  }
  clearPending();
  return null;
};
